import React from "react";
import { Box, Typography, useTheme, Link, useMediaQuery } from "@mui/material";

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width:900px)");
  const currentYear = new Date().getFullYear();

  const textStyle = {
    ...theme.footer.text,
    color: theme.palette.footer.text,
  };

  const linkStyle = {
    ...textStyle,
    textDecoration: "none",
    transition: "color 0.2s",
    "&:hover": {
      color: theme.palette.primary.main,
    },
  };

  return (
    <Box
      component="footer"
      sx={{
        height: isMobile ? "auto" : "100px",
        backgroundColor: theme.palette.footer.background,
        display: "flex",
        ...(isMobile
          ? {
              flexDirection: "column",
              padding: "40px 21px",
            }
          : {
              alignItems: "center",
              justifyContent: "flex-end",
              paddingRight: "130px",
            }),
      }}
    >
      {isMobile ? (
        <>
          <Typography sx={textStyle}>
            © Exaccly Pty Ltd ABN 86 643 294 937 - {currentYear}. All rights reserved
          </Typography>
          <Box height="32px" />
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Link
              sx={linkStyle}
              href="https://exacc.au/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer--Link-0">
              Privacy Policy
            </Link>
            <Box width="32px" />
            <Link
              sx={linkStyle}
              href="https://exacc.au/terms-of-use"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer--Link-1">
              Terms of Use
            </Link>
          </Box>
        </>
      ) : (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography sx={textStyle}>
            © Exaccly Pty Ltd ABN 86 643 294 937 - {currentYear}. All rights reserved
          </Typography>
          <Box width="32px" />
          <Link
            sx={linkStyle}
            href="https://exacc.au/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer--Link-2">
            Privacy Policy
          </Link>
          <Box width="32px" />
          <Link
            sx={linkStyle}
            href="https://exacc.au/terms-of-use"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer--Link-3">
            Terms of Use
          </Link>
        </Box>
      )}
    </Box>
  );
};

export default Footer;
